import React from "react";
import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import { utilUpdatePlatilloMenu } from "../util/UtilsFirebase";

import "./PreciosModal.css";
const PreciosModal = ({
  menu,
  showPrecios,
  mod,
  itemPlatillo,
  handleClosePrecios,
}) => {
  const [initialPreciosState] = useState({
    img: null,
    name: "",
    active: true,
    description: "",
    ncosto1: "",
    costo1: "",
    puntos1: "0",
    ncosto2: "",
    costo2: "",
    puntos2: "0",
    ncosto3: "",
    costo3: "",
    puntos3: "0",
    show: true,
    available: true,
  });
  const [ingredientenuevo] = useState({
    ingrediente: null,
    cantidad: 0,
  });
  const [Precios, setPrecios] = useState(initialPreciosState);
  const [isDelete, setIsDelete] = useState(false);
  const [categoriaSelected, setcategoriaSelected] = useState(null);
  const [rowsI, setRowsI] = useState([ingredientenuevo]);

  const handleChange = (e) => {
    setPrecios({
      ...Precios,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (showPrecios) {
      console.log("EntroPrecios");

      if (mod) {
        if (itemPlatillo) {
          setPrecios(itemPlatillo);
          if (itemPlatillo.Precios != null) {
            setRowsI(itemPlatillo.Precios);
          } else {
            setRowsI([ingredientenuevo]);
          }

          if (mod === "UPD") {
            setcategoriaSelected(itemPlatillo.categoria);
          }

          if (mod === "ADD") {
            setPrecios(initialPreciosState);
            setcategoriaSelected(0);
          }

          if (mod === "DLT") {
            setIsDelete(true);
            setcategoriaSelected(itemPlatillo.categoria);
          } else {
            setIsDelete(false);
          }
        } else {
          setPrecios(initialPreciosState);
          setRowsI([ingredientenuevo]);
        }
      }
    }
  }, [
    showPrecios,
    itemPlatillo,
    mod,
    menu,
    ingredientenuevo,
    initialPreciosState,
  ]);

  const handleCloseLocal = async () => {
    //setPrecios(null);
    setcategoriaSelected(0);
    setRowsI([ingredientenuevo]);
    handleClosePrecios();
  };

  const savePrecios = async () => {
    if (mod === "ADD") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      let ingredienteIncompleto = false;
      rowsI.forEach((element) => {
        if (element.ingrediente == null) {
          alert("Seleccione todos los ingredientes");
          btn.disabled = false;
          ingredienteIncompleto = true;
        }
        if (element.cantidad === 0) {
          alert("Coloque una cantidad para todos los ingredientes");
          btn.disabled = false;
          ingredienteIncompleto = true;
        }
      });
      if (ingredienteIncompleto) {
        return;
      }
      Precios.Precios = rowsI;

      utilUpdatePlatilloMenu(menu.id, categoriaSelected.id, Precios);
      setRowsI([ingredientenuevo]);
      handleClosePrecios();
    }

    if (mod === "UPD") {
      if (
        (!Precios.ncosto1 || !Precios.costo1) &&
        (!Precios.ncosto2 || !Precios.costo2) &&
        (!Precios.ncosto3 || !Precios.costo3)
      ) {
        alert("Seleccione al menos una Presentacion con Costo");
        return;
      }

      if (
        (Precios.ncosto1 !== "" &&
          (!Precios.costo1 || parseFloat(Precios.costo1) <= 0)) ||
        (Precios.ncosto2 !== "" &&
          (!Precios.costo2 || parseFloat(Precios.costo2) <= 0)) ||
        (Precios.ncosto3 !== "" &&
          (!Precios.costo3 || parseFloat(Precios.costo3) <= 0))
      ) {
        alert("Añada un precio a las presentaciones con nombre");
        return;
      }
      if (
        (Precios.ncosto1 === "" &&
          (Precios.costo1 || parseFloat(Precios.costo1) === 0)) ||
        (Precios.ncosto2 === "" &&
          (Precios.costo2 || parseFloat(Precios.costo2) === 0)) ||
        (Precios.ncosto3 === "" &&
          (Precios.costo3 || parseFloat(Precios.costo3) === 0))
      ) {
        alert("Añada un nombre a las presentaciones con precio");
        return;
      }
      utilUpdatePlatilloMenu(menu.id, categoriaSelected.id, Precios);
      //setPrecios(null);
      setRowsI([ingredientenuevo]);
      handleClosePrecios();
    }
  };

  return (
    <Modal show={showPrecios} onHide={handleClosePrecios} size="lg">
      <Modal.Header closeButton>
        <Modal.Title> Precios </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col md={4} className="border-end">
              <Form.Group controlId="razonSocial">
                Nombre de la presentacion
                <Form.Control
                  placeholder="Presentacion 1"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.ncosto1}
                  name="ncosto1"
                  required
                  type="text"
                />
                Precio
                <Form.Control
                  placeholder="0.00"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.costo1}
                  name="costo1"
                  required
                  type="number"
                />
                Puntos
                <Form.Control
                  placeholder="0"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.puntos1}
                  name="puntos1"
                  required
                  type="number"
                />
              </Form.Group>
            </Col>
            <Col md={4} className="border-end">
              <Form.Group controlId="razonSocial">
                Nombre de la presentacion
                <Form.Control
                  placeholder="Presentacion 2"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.ncosto2}
                  name="ncosto2"
                  required
                  type="text"
                />
                Precio
                <Form.Control
                  placeholder="0.00"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.costo2}
                  name="costo2"
                  required
                  type="number"
                />
                Puntos
                <Form.Control
                  placeholder="0"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.puntos2}
                  name="puntos2"
                  required
                  type="number"
                />
              </Form.Group>
            </Col>
            <Col md={4} className="border-end">
              <Form.Group controlId="razonSocial">
                Nombre de la presentacion
                <Form.Control
                  placeholder="Presentacion 3"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.ncosto3}
                  name="ncosto3"
                  required
                  type="text"
                />
                Precio
                <Form.Control
                  placeholder="0.00"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.costo3}
                  name="costo3"
                  required
                  type="number"
                />
                Puntos
                <Form.Control
                  placeholder="0"
                  className="mrg-costos"
                  disabled={isDelete}
                  onChange={handleChange}
                  value={Precios?.puntos3}
                  name="puntos3"
                  required
                  type="number"
                />
              </Form.Group>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseLocal}>
          CANCELAR
        </Button>
        <Button
          id="BtnGuardar"
          variant={mod && mod === "DLT" ? "danger" : "primary"}
          onClick={savePrecios}
        >
          {mod && mod === "DLT" ? "ELIMINAR" : "GUARDAR"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreciosModal;
